import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./home/Home";
import HsluHeader from "./app-header/HsluHeader";
import SearchUnified from "./search-unified/SearchUnified";
import Detail from "./detail/Detail";
import Recherche from "./recherche/Recherche";
import DetailRedirectToLatest from "./legacy/DetailRedirectToLatest";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div>
        <HsluHeader />
        <div className="main container">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/recherche" component={Recherche} />
            <Route path="/search-unified" component={SearchUnified} />
            <Redirect from="/search" to="/search-unified/orgelsuche" />
            <Redirect from="/search-builder" to="/search-unified/orgelbaue" />

            <Route
              path="/detail/:id/0/orgel"
              render={({ match }) => (
                <Redirect to={`/detail/${match.params.id}`} />
              )}
            />
            <Route
              path="/detail/:id/1/orgelbauer"
              render={({ match }) => (
                <Redirect to={`/detail/${match.params.id}/rawdata`} />
              )}
            />
            <Route
              path="/detail-orgelbauer/:id"
              render={({ match }) => (
                <Redirect to={`/detail/${match.params.id}`} />
              )}
            />
            <Route
              path="/detail-orgel/:id"
              render={({ match }) => (
                <Redirect to={`/detail/${match.params.id}/recent`} />
              )}
            />
            <Route
              path="/detail/:id/recent"
              component={DetailRedirectToLatest}
            />

            <Route path="/detail/:id" component={Detail} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js